import React from "react";
import "./common-tabel.m.css";
import { formatRate } from '../util';

const TenGramRate = ({perGramRate, country}) => {
  if (!perGramRate || perGramRate <= 0) return '-';
  if (country === "India") {
    return (
      <span>
      {formatRate(perGramRate)}
      <span styleName="ten-gram-rate">₹{formatRate(perGramRate * 10)} / 10g</span>
      </span>
    );
  }
  return (
    <span>{formatRate(perGramRate)}</span>
  );
};


const GoldRateTable = ({ goldApidata, country }) => {
  const rates = goldApidata || {};
  const ratesArr = rates.carat21?.morning > 0 ? ["carat18", "carat21", "carat22", "carat24"] : ["carat18", "carat22", "carat24"];
  const sortedRates = Object.entries(rates)
    .filter(([carat]) => {
      return  ratesArr.includes(carat);
    })
    .sort((a, b) => parseInt(b[0].replace("carat", ""), 10) - parseInt(a[0].replace("carat", ""), 10));


  return (
    <div styleName="table-container">
      <table styleName="rate-exchange-table gold-table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Morning</th>
            <th>Afternoon</th>
            <th>Evening</th>
            <th>Yesterday</th>
          </tr>
        </thead>

        <tbody>
          {sortedRates?.length > 0 ? (
            sortedRates?.map(([carat, prices]) => (
              <tr key={carat}>
                <td>{`${carat.replace("carat", "")} Carat`}</td>
                <td><TenGramRate perGramRate={prices?.morning} country={country} /></td>
                <td><TenGramRate perGramRate={prices?.afternoon} country={country} /></td>
                <td><TenGramRate perGramRate={prices?.evening} country={country} /></td>
                <td><TenGramRate perGramRate={prices?.yesterday} country={country} /></td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default GoldRateTable;
